/**
 * Handles the closeable defensive driving notice.
 */
export const initDefensiveDrivingNotice = () => {
    const handleNotice = () => {
        const notice = document.querySelector('.crsc-defensive-driving-notice') as HTMLElement;
        if (!notice) return;

        const urlParams = new URLSearchParams(window.location.search);
        const categories = urlParams.get('_product_categories');
        const isDDFiltered = categories && categories.split(',').includes('defensive-driving');

        const isShop = document.body.classList.contains('archive') && document.body.classList.contains('post-type-archive-product') || document.body.classList.contains('home');
        
        // If we are on the shop page, show/hide based on FacetWP filter
        if (isShop) {
            // Check if we are on a DD category archive (which shouldn't be hidden by JS if we want it always visible there)
            // But usually shop page is separate from category archive.
            // If it's a category archive, it won't have 'post-type-archive-product' but 'tax-product_cat'
            if (isDDFiltered) {
                //notice.style.display = 'block';
            } else if (!document.body.classList.contains('tax-product_cat')) {
                // Only hide if not a category page (PHP handles category page logic)
                 //notice.style.display = 'none';
            }
        }
    };

    handleNotice();

    // Re-check when FacetWP finishes loading
    document.addEventListener('facetwp-loaded', handleNotice);
};
